import api from './api';

const searchService = {
  async searchTelegramHistory(query, options = {}) {
    const response = await api.get('/search/telegram-history', {
      params: {
        query,
        chatLimit: options.chatLimit,
        messageLimit: options.messageLimit,
        historyChatScanLimit: options.historyChatScanLimit,
        historyMessagesPerChat: options.historyMessagesPerChat,
      },
    });

    return response.data;
  },
};

export default searchService;
